module.exports = __webpack_public_path__ + "img/features-support-02.b4c12db0.jpg";